import React, { useState } from "react";
import "./Search.css";
import "./styles.css";

export default function Temperatura(props) {
let  [unit, setUnit]=useState("celsius");
function fahrenheitShow(event) {
  event.preventDefault();  
  setUnit("fahrenheit");}

  function  celciusShow(event){
    event.preventDefault(); 
    setUnit("celsius");
  }
  
if (unit==="celsius"){
return(
<span >
                  Temperature{" "}
                  <span id="temper"> {Math.round(props.celsius)}</span>
                  <span className="celsiusFah" id="celsiusFah" >                    
                      <big>°C</big>
                    |
                    <a href="/" className="fahrenheit" id="fahrenheit" onClick={fahrenheitShow} >
                     <small>°F</small> 
                    </a>
                  </span>
                </span>);                
              } else {
                let fahrenheit=(props.celsius*9/5)+32;
                return (
                  <span>
                  Temperature{" "}
                  <span id="temper"> {Math.round(fahrenheit)}</span>
                  <span className="celsiusFah" id="celsiusFah">
                    <a href="/" className="celsius" id="celsius" onClick={celciusShow}>
                      <small>°C</small>
                    </a>|                    
                      <big>°F</big>                  
                  </span>
                </span>);  
                
              }
            }

